import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { createTrackingProps } from 'shared-utils/analytics';

export const FormLabel = styled(Typography).attrs({
  styledAs: 'bodySmallSpaceGrotesk',
  renderedAs: 'label',
  weight: 500,
  // By default, we'll allow Form labels to be unmasked. They should never contain PHI.
  ...createTrackingProps({ unmask: true }),
})`
  margin-bottom: 4px;
`;
